(function(){
  if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var raf = window.requestAnimationFrame || function(c){return setTimeout(c,16)};

  // ---- TILT 3D on cards ----
  function attachTilt(selector, opts){
    opts = opts || {};
    var max = opts.max || 8;       // max degrees
    var glare = opts.glare || false;
    document.querySelectorAll(selector).forEach(function(card){
      // Auto-add data-tilt attr
      if (!card.hasAttribute('data-onamaste-tilt')) card.setAttribute('data-onamaste-tilt','');
      var rect, target = card;
      function update(e){
        rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        var rx = -py * max;
        var ry = px * max;
        card.style.transform = 'perspective(1100px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg) translateZ(0)';
      }
      function reset(){ card.style.transform = ''; }
      card.addEventListener('mousemove', update);
      card.addEventListener('mouseleave', reset);
    });
  }
  attachTilt('.ed-chap-row', {max:5});
  attachTilt('.ed-edit-card', {max:8});
  attachTilt('.pdp-related-card', {max:7});
  attachTilt('.ona5-scroll-card', {max:6});

  // ---- PARALLAX on hero ----
  function setupParallax(){
    var els = document.querySelectorAll('[data-parallax-y]');
    if (!els.length) return;
    function tick(){
      var sy = window.scrollY;
      els.forEach(function(el){
        var speed = parseFloat(el.getAttribute('data-parallax-y')) || 0.2;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height/2;
        var viewport = window.innerHeight;
        // displacement based on distance from viewport center
        var d = (center - viewport/2) * -speed;
        el.style.transform = 'translateY('+d.toFixed(1)+'px)';
      });
    }
    document.addEventListener('scroll', tick, {passive:true});
    tick();
  }
  setupParallax();

  // Auto-add parallax to hero text + image
  document.querySelectorAll('.ed-cover-text').forEach(function(el){
    if (!el.hasAttribute('data-parallax-y')) el.setAttribute('data-parallax-y','0.08');
  });
  // Re-init since attribute was just added
  setupParallax();
})();